export enum PropertyCategory
{
    Common = 0,
    Layout = 1,
    Appearance = 2,
    Text = 3,
    Events = 4,
    Custom = 5,
}
